module.exports = __webpack_public_path__ + "img/photo-3.1464802e.png";